/**
 * In-memory rasters keyed by underlay id so the map can render after
 * `imageDataUrl` is stripped from the project document.
 */
const rastersById = new Map<string, string>();

/**
 * Remember a client-side raster (import or fetched GET).
 */
export const rememberBlueprintRaster = (
  underlayId: string,
  imageDataUrl: string,
): void => {
  rastersById.set(underlayId, imageDataUrl);
};

/**
 * Remember many client-side rasters (socket snapshot or enrich worker).
 */
export const rememberBlueprintRasters = (
  imagesById: Record<string, string>,
): void => {
  for (const [underlayId, imageDataUrl] of Object.entries(imagesById)) {
    if (imageDataUrl) rememberBlueprintRaster(underlayId, imageDataUrl);
  }
};

/**
 * Drop a cached raster when the page is removed.
 */
export const forgetBlueprintRaster = (underlayId: string): void => {
  rastersById.delete(underlayId);
};

/**
 * Resolve a raster for the map: explicit data URL, else cache.
 */
export const resolveBlueprintRaster = (
  underlayId: string,
  imageDataUrl: string | undefined,
): string | undefined => imageDataUrl || rastersById.get(underlayId);
